import { Box, Grid, Theme, Typography } from "@mui/material";
import { KeyValue } from "../../ApplicationDetails/personalDetails";
import { ViewProfileProps } from "../types";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";
import { getUniqueIdentityText, isOnboardingTypeMinor } from "../../../utils/utilityFunctions";


export default function ViewProfileOverview({ overviewData }: { overviewData: any }): JSX.Element {
    const { name, pan, email, mobile } = overviewData;
    const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)

    const isMinor = isOnboardingTypeMinor(overviewData?.onboardingType || '');
    const investorName = isMinor ? `${overviewData?.applicants?.[0]?.minorFirstName} ${overviewData?.applicants?.[0]?.minorLastName}` : name;

    const validPan = isMinor ? overviewData?.applicants?.[0]?.minorPan : pan;
    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'white',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'

                })}
            >
                <Box>
                    <Grid container >
                        <Grid item xs={12} >
                            <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '25px' })}>
                                Overview
                            </Typography>

                        </Grid>
                        <Grid
                            item
                            container
                            rowSpacing={3}
                            columnSpacing={5.5}
                            direction="row"

                        >
                            <KeyValue title={'Name'} description={investorName} />
                            <KeyValue
                                title={`${getUniqueIdentityText(company)?.pan}`}
                                description={isMinor ? validPan : pan}
                            />
                            <KeyValue title={'Mobile Number'} description={`${overviewData?.applicants?.[0]?.countryCode ?? ""} ${overviewData?.applicants?.[0]?.mobile ?? "-"}`} />
                            <KeyValue title={'Email ID'} description={email} />

                        </Grid>

                    </Grid>
                </Box>
            </Box >
        </>
    )
}